// extracted by mini-css-extract-plugin
export var dropdown = "_tu-0";
export var imageWrapper = "_tu-3";
export var itemNameContainer = "_tu-1";
export var productImage = "_tu-2";
export var spinnerWrapper = "_tu-4";